import { cn } from '../../lib/utils';

interface PanelHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Left slot — typically a title, breadcrumb, or mobile menu toggle + title. */
  left?: React.ReactNode;
  /** Optional center slot — e.g. tab/view toggles. */
  center?: React.ReactNode;
  /** Right slot — action buttons, dropdowns. */
  right?: React.ReactNode;
  className?: string;
  /** Override classes on the left slot wrapper (default includes `flex-1`). */
  leftClassName?: string;
  /** Override classes on the center slot wrapper. */
  centerClassName?: string;
  /** Override classes on the right slot wrapper. */
  rightClassName?: string;
}

/**
 * Unified detail-panel header bar.
 * Provides a consistent `h-11` height, border, and background across all
 * detail panels (AgentStreamView, ChatView, AxonDetailPage, etc.).
 */
export function PanelHeader({
  left,
  center,
  right,
  className,
  leftClassName,
  centerClassName,
  rightClassName,
  ...props
}: PanelHeaderProps) {
  return (
    <div
      className={cn(
        'flex h-11 shrink-0 items-center gap-1.5 border-b border-border/30 bg-panel/80 px-4 backdrop-blur-xl',
        className,
      )}
      {...props}
    >
      <div className={cn('flex min-w-0 flex-1 items-center gap-2.5', leftClassName)}>{left}</div>
      {center && (
        <div className={cn('flex min-w-0 items-center gap-2', centerClassName)}>{center}</div>
      )}
      {right && (
        <div className={cn('flex shrink-0 items-center gap-1', rightClassName)}>{right}</div>
      )}
    </div>
  );
}
